import React from "react";

import Autocomplete from "@material-ui/lab/Autocomplete";

export default function CustomAutocompleteInput({
  options,
  values,
  customGetOptionLabel,
  customRenderedInput,
  customOnChangeFunction,
  customRenderOption,
  customRenderTags,
  ...props
}) {
  return (
    <Autocomplete
      {...props}
      multiple
      value={values}
      options={options}
      getOptionLabel={(option) => customGetOptionLabel(option)}
      renderInput={(params) => customRenderedInput(params)}
      onChange={(event, newValue) => {
        if (newValue) {
          customOnChangeFunction(newValue);
        }
      }}
      renderTags={(value, getTagProps) => value.map((option, index) => customRenderTags(option, index, getTagProps))}
      renderOption={(option) => customRenderOption(option)}
    />
  );
}
